import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DynamicCrudService } from 'src/app/___LOGIC/__crud/dynamic-crud.service';

@Component({
  selector: 'app-dynamic-input',
  templateUrl: './dynamic-input.component.html',
  styleUrls: ['./dynamic-input.component.css']
})
export class DynamicInputComponent implements OnInit {

  @Input() data;
  @Output() public dataOut = new EventEmitter();
  // GUI Values
  inputHint;
  placeholder = '';
  editMode = false;

  constructor(private dynamicCrudService: DynamicCrudService) { }

  ngOnInit(): void {
    // Field Name From CrudFieldsService
    if(this.data){
      this.data.value? null : this.data.value = null;
      this.data.columnName? null : this.data.columnName = '';
    }
  }

  onInputType(event: any) {
    this.data.value =  event.target.value;
    this.dataOut.emit(this.data);
  }

  getShortValue(buffer: any): string {
    if (typeof buffer === 'string') {
      return buffer.slice(0, 15);
    } else if (typeof buffer === 'number') {
      return buffer.toString(); // Convert number to string
    } else {
      return '';
    }
  }

  isEditMode(){
    return this.editMode && this.dynamicCrudService.isCurrentFieldEditing(this.data.columnName);
  }

  switchEditingMode(){
    this.editMode = !this.editMode;
    this.editMode? this.dynamicCrudService.setCurrentFieldToEdit(this.data.columnName): null;
  }

}
